import { render, staticRenderFns } from "./customer-analyse.vue?vue&type=template&id=0a3dd854&scoped=true&"
import script from "./customer-analyse.vue?vue&type=script&lang=js&"
export * from "./customer-analyse.vue?vue&type=script&lang=js&"
import style0 from "./customer-analyse.vue?vue&type=style&index=0&id=0a3dd854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3dd854",
  null
  
)

export default component.exports